import { createSlice } from '@reduxjs/toolkit'

export interface CurrentUser {
  id?: string
  email?: string
  role?: string

  eventAdmission?: boolean
  passType?: 'dp' | 'aap_virtual' | 'aap_lite' | 'aap_premium'
  memberType?:
    | 'Discovery Pass Virtual'
    | 'All Access Pass Virtual'
    | 'All Access Pass Lite'
    | 'All Access Pass Premium'

  firstName?: string
  lastName?: string
  fullName?: string

  companyName?: string
  qrLabel?: string
}

export interface AuthState {
  isAuthLoading: boolean
  isAuthenticated: boolean
  currentUser?: CurrentUser
}

const initialState: AuthState = {
  isAuthLoading: false,
  isAuthenticated: localStorage.getItem('jwt_token') ? true : false,
  currentUser: undefined,
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loggingIn: (state) => {
      state.isAuthLoading = true
    },
    loggedIn: (state, action) => {
      state.isAuthLoading = false
      state.currentUser = action.payload
      state.isAuthenticated = true
    },
    loggedOut: (state) => {
      state.isAuthLoading = false
      state.currentUser = undefined
      state.isAuthenticated = false
    },
    updatedUser: (state, action) => {
      state.isAuthLoading = false
      state.currentUser = action.payload
      state.isAuthenticated = true
    },
  },
})

export const { loggingIn, loggedIn, loggedOut, updatedUser } = authSlice.actions

export default authSlice.reducer
